import React from "react";
import { Link } from "react-router-dom";
import { useSite } from "../theme/ThemeProvider";

const LOGO_SRC = "/images/brand/mahir-usta-otogaz.svg";
const LOGO_SRC_LIGHT = "/images/brand/mahir-usta-otogaz-mono-beyaz.svg";

export const LogoMark = ({ className = "logo__mark", light = false }) => (
  <img
    className={className}
    src={light ? LOGO_SRC_LIGHT : LOGO_SRC}
    alt=""
    aria-hidden="true"
    width="1200"
    height="420"
    loading="eager"
    decoding="async"
  />
);

const Logo = ({ light = false, to = "/" }) => {
  const site = useSite();
  return (
    <Link to={to} className={`logo${light ? " logo--light" : ""}`} aria-label={site.name}>
      <LogoMark light={light} />
    </Link>
  );
};

export default Logo;
